import { Cpu } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-secondary to-background py-16 md:py-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-nvidia/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amd/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6 animate-fade-in">
            <Cpu className="w-4 h-4 text-primary" />
            <span className="text-sm font-medium text-primary">Updated December 2024</span>
          </div>

          {/* H1 - Main keyword */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground mb-6 animate-fade-in" style={{ animationDelay: '0.1s' }}>
            Complete{' '}
            <span className="bg-gradient-to-r from-nvidia via-primary to-amd bg-clip-text text-transparent">
              GPU Comparison
            </span>{' '}
            Chart
          </h1>

          {/* H2 - Secondary keywords */}
          <h2 className="text-xl md:text-2xl text-muted-foreground mb-8 font-medium animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Compare all graphics cards from NVIDIA, AMD, and Intel — ranked by performance
          </h2>

          {/* Description */}
          <p className="text-muted-foreground max-w-2xl mx-auto mb-10 animate-fade-in" style={{ animationDelay: '0.3s' }}>
            Find the best graphics card for your budget. Our GPU comparison ranks every modern graphics card 
            from the RTX 5090 to budget options, helping you make the right choice for gaming, 
            content creation, or professional work.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 md:gap-8 max-w-xl mx-auto animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <div className="p-4 rounded-xl bg-card border shadow-card">
              <div className="text-2xl md:text-3xl font-bold text-nvidia mb-1">26+</div>
              <div className="text-xs md:text-sm text-muted-foreground">GPUs Compared</div>
            </div>
            <div className="p-4 rounded-xl bg-card border shadow-card">
              <div className="text-2xl md:text-3xl font-bold text-primary mb-1">3</div>
              <div className="text-xs md:text-sm text-muted-foreground">Major Brands</div>
            </div>
            <div className="p-4 rounded-xl bg-card border shadow-card">
              <div className="text-2xl md:text-3xl font-bold text-amd mb-1">4</div>
              <div className="text-xs md:text-sm text-muted-foreground">Performance Tiers</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
